module.exports = __webpack_public_path__ + "img/logo_sistema_sem_fundo.7ee7402d.png";